﻿// --- START OF FILE Footer.jsx ---

import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Twitter, Github } from 'lucide-react';
// --- UPDATE: Import the logo for Footer ---
import vvaLogo from '../assets/vva-logo.png';

const Footer = () => {
  const footerSections = [
    {
      title: 'Solutions',
      links: ['Trading Systems', 'Low Latency', 'Infrastructure', 'Analytics']
    },
    {
      title: 'Company',
      links: ['About', 'Contact']
    },
    {
      title: 'Legal',
      links: ['Privacy Policy', 'Terms of Service']
    }
  ];

  const socialLinks = [
    { 
      icon: Linkedin, 
      name: 'LinkedIn', 
      href: 'https://www.linkedin.com/company/vegavelox-analytech/about/', 
      status: 'active'
    },
    { 
      icon: Twitter, 
      name: 'Twitter', 
      href: '#', 
      status: 'under-construction' 
    },
    { 
      icon: Github, 
      name: 'GitHub', 
      href: '#', 
      status: 'under-construction' 
    }
  ];

  return (
    <footer className="relative bg-black/20 border-t border-[hsl(var(--border))]">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12">
          
          {/* Brand Section */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="md:col-span-2"
          >
            {/* --- UPDATED BRAND BLOCK: Logo + Text Stack --- */}
            <div className="flex items-center gap-5 mb-6">
              
              {/* Footer Logo */}
              <img 
                src={vvaLogo} 
                alt="VegaVelox Emblem" 
                className="h-16 w-auto object-contain brand-logo-img" 
              />

              {/* Text Stack */}
              <div className="flex flex-col items-start">
                {/* 1. Main Title */}
                <h1 className="brand-title gradient-text text-2xl md:text-3xl leading-none whitespace-nowrap">
                  VEGAVELOX ANALYTECH
                </h1>

                {/* 2. Peacock Blue Separator */}
                <div className="brand-separator w-full my-2"></div>

                {/* 3. Subtitle: PRIVATE LIMITED */}
                <span className="brand-subtitle text-xs w-full text-center tracking-[0.3em]">
                  PRIVATE LIMITED
                </span>
              </div>
            </div>
            {/* --- END BRAND BLOCK --- */}

            <p className="text-[hsl(var(--muted-foreground))] leading-relaxed">
              Empowering the future of financial trading with cutting-edge technology, ultra-low latency solutions, and unparalleled performance.
            </p>
          </motion.div>
          
          {/* Links Sections */}
          {footerSections.map((section, index) => (
            <motion.div
              key={section.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 + index * 0.1 }}
              viewport={{ once: true }}
            >
              <h3 className="text-lg font-bold text-white mb-6 block">
                {section.title}
              </h3>
              <ul className="space-y-4">
                {section.links.map((link) => (
                  <li key={link}>
                    <a href="#" className="text-[hsl(var(--muted-foreground))] hover:text-white transition-colors duration-200">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Bottom Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          viewport={{ once: true }}
          className="border-t border-[hsl(var(--border))] mt-16 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0"
        >
          <p className="text-[hsl(var(--muted-foreground))] text-sm">
            © 2025 VegaVelox Analytech Private Limited. All rights reserved.
          </p>
          <div className="flex space-x-4">
            {socialLinks.map((social) => (
              <motion.a
                key={social.name}
                href={social.href}
                target={social.status === 'active' ? "_blank" : "_self"}
                rel={social.status === 'active' ? "noopener noreferrer" : ""}
                title={social.status === 'under-construction' ? "Under Construction" : social.name}
                whileHover={{ scale: 1.1 }}
                className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${
                  social.status === 'under-construction' 
                    ? 'bg-[hsl(var(--card))] text-gray-600 cursor-not-allowed'
                    : 'bg-[hsl(var(--card))] hover:bg-[hsl(var(--primary-gold))] text-[hsl(var(--muted-foreground))] hover:text-black'
                }`}
              >
                <social.icon className="w-5 h-5" />
              </motion.a>
            ))}
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
// --- END OF FILE Footer.jsx ---